import ClientsBalanceTab from './ClientsBalanceTab';

export default ClientsBalanceTab;
